<template>
  <div>
    <div class="card card-outline">
      <div class="card-body">
        <div class="row">
          <div class="col-6 col-md-4 text-center align-self-center mb-3">
            <svg class="svg-1" data-name="Capa 1" viewBox="0 0 663.79 467.42" xmlns="http://www.w3.org/2000/svg">
              <title>Camera</title>
              <rect class="cls-1" x="47.03" y="35.04" width="84" height="82" rx="20" ry="20"/>
              <path class="cls-2" :fill="palette.color1" transform="translate(-151.97 -191.96)"
                    d="M815.76,288.46A27.44,27.44,0,0,0,788.4,261.1h-25L752.73,223a42.57,42.57,0,0,0-41-31.05H516.5a45.83,45.83,0,0,0-43.86,32.54l-11.09,36.6H179.33A27.44,27.44,0,0,0,152,288.46V407H815.76Z"/>
              <path class="cls-3" :fill="palette.color2" transform="translate(-151.97 -191.96)"
                    d="M152,407V632a27.44,27.44,0,0,0,27.36,27.36H788.4A27.44,27.44,0,0,0,815.76,632V407Z"/>
              <path class="cls-4" :fill="palette.color2" transform="translate(-151.97 -191.96)"
                    d="m369.69 446.51c0 66 54.91 119.49 122.65 119.49a124.31 124.31 0 0 0 70.41 -21.64l-138-197.56c-33.17 21.38-55.06 58.05-55.06 99.71z"/>
              <path class="cls-5" :fill="palette.color3" transform="translate(-151.97 -191.96)"
                    d="M613,456.51c0-66-54.91-119.49-122.65-119.49a124.39,124.39,0,0,0-67.59,19.78l138,197.56C592.35,532.74,613,497,613,456.51Z"/>
              <ellipse class="cls-6" :fill="palette.color4" cx="336.36" cy="262.53" rx="122.65" ry="119.49"/>
              <rect class="cls-7" :fill="palette.color5" x="401.03" y="23.04" width="127.42" height="52" rx="26"
                    ry="26"/>
              <circle class="cls-8" cx="60.03" cy="390.04" r="19"/>
              <circle class="cls-5" :fill="palette.color3" cx="58.03" cy="334.04" r="19"/>
            </svg>
          </div>
          <div class="col-6 col-md-4 text-center align-self-center mb-3">
            <svg class="svg-2" data-name="Capa 1" viewBox="0 0 581.24 345.71" xmlns="http://www.w3.org/2000/svg">
              <title>Pc-icon</title>
              <path class="cls-1" transform="translate(-279.76 -211.29)" d="m560 413s91 140 238 99"/>
              <path class="cls-1" transform="translate(-279.76 -211.29)" d="m541 423.5s91 140 238 99"/>
              <polygon class="cls-2" :fill="palette.color1"
                       points="230.58 323.95 186.58 323.95 166.17 56.09 248.93 56.09"/>
              <rect class="cls-3" :fill="palette.color2" width="412.32" height="271" rx="27.36" ry="27.36"/>
              <rect class="cls-4" :fill="palette.color2" x="125.17" y="310.63" width="169.4" height="33" rx="16.5"
                    ry="16.5"/>
              <path class="cls-5" :fill="palette.color3" transform="translate(-279.76 -211.29)"
                    d="M664,436.26V250.35a16,16,0,0,0-16.22-15.74H325.22a16.37,16.37,0,0,0-12.79,6.12L660,446.51A15.39,15.39,0,0,0,664,436.26Z"/>
              <path class="cls-6" :fill="palette.color4" transform="translate(-279.76 -211.29)"
                    d="M312.42,240.73a15.35,15.35,0,0,0-3.42,9.62V436.26A16,16,0,0,0,325.22,452H647.78A16.38,16.38,0,0,0,660,446.51Z"/>
              <rect class="cls-4" :fill="palette.color2" transform="translate(116.28 960.26) rotate(-90)" x="614.54"
                    y="310.54" width="338.5"
                    height="154.42" rx="9.44" ry="9.44"/>
              <rect class="cls-2" :fill="palette.color1" transform="translate(116.53 956.99) rotate(-90)" x="633.28"
                    y="331.28" width="298"
                    height="109.43" rx="7.53" ry="7.53"/>
              <circle class="cls-7" :fill="palette.color5" cx="504.24" cy="92.71" r="19"/>
              <line class="cls-8" x1="464.82" x2="541.32" y1="185.31" y2="185.31"/>
              <line class="cls-8" x1="464.82" x2="541.32" y1="199.31" y2="199.31"/>
              <line class="cls-8" x1="464.82" x2="541.32" y1="211.81" y2="211.81"/>
              <line class="cls-8" x1="464.82" x2="541.32" y1="225.81" y2="225.81"/>
              <circle class="cls-9" :fill="palette.color2" cx="504.24" cy="92.71" r="7"/>
              <rect class="cls-10" x="463.99" y="241.96" width="17.5" height="8.3" rx="2" ry="2"/>
              <rect class="cls-10" x="493.99" y="241.71" width="17.5" height="8.3" rx="2" ry="2"/>
              <rect class="cls-10" x="523.74" y="241.46" width="17.5" height="8.3" rx="2" ry="2"/>
            </svg>
          </div>
          <div class="col-md-4 text-center align-self-center mb-3">
            <svg class="svg-3" data-name="Capa 1" viewBox="0 0 417.21 449.91" xmlns="http://www.w3.org/2000/svg">
              <title>Backpack</title>
              <rect class="cls-1" y="292.72" width="41.72" height="106.9" rx="12.58" ry="12.58"/>
              <ellipse class="cls-2" :fill="palette.color1" cx="208.72" cy="95.25" rx="64.5" ry="89.25"/>
              <rect class="cls-1" x="375.49" y="291.72" width="41.72" height="106.9" rx="12.58" ry="12.58"/>
              <path class="cls-3" :fill="palette.color2"
                    d="M199,37.84h19A165.52,165.52,0,0,1,383.47,203.36V422.55a27.36,27.36,0,0,1-27.36,27.36H60.83a27.36,27.36,0,0,1-27.36-27.36V203.36A165.52,165.52,0,0,1,199,37.84Z"/>
              <rect class="cls-4" :fill="palette.color2" x="92.09" y="293.01" width="229.31" height="110.34" rx="27.36"
                    ry="27.36"/>
              <line class="cls-5" :fill="palette.color3" x1="121.4" x2="292.09" y1="325.77" y2="325.77"/>
              <line class="cls-6" :fill="palette.color4" x1="121.4" x2="123.9" y1="325.77" y2="325.77"/>
              <line class="cls-7" :fill="palette.color5" x1="128.93" x2="287.08" y1="325.77" y2="325.77"/>
              <line class="cls-6" :fill="palette.color4" x1="289.59" x2="292.09" y1="325.77" y2="325.77"/>
              <path class="cls-8"
                    d="M165.64,121.52h83.21a73,73,0,0,1,73,73v9.93a27.36,27.36,0,0,1-27.36,27.36H120A27.36,27.36,0,0,1,92.59,204.5v-9.93A73.05,73.05,0,0,1,165.64,121.52Z"/>
              <path class="cls-9" :fill="palette.color2" transform="translate(672.81 502.09) rotate(180)"
                    d="M428.09,327.1h76.5a9,9,0,0,1,9,9v0a22.5,22.5,0,0,1-22.5,22.5H441.6a22.5,22.5,0,0,1-22.5-22.5v0a9,9,0,0,1,9-9Z"/>
              <rect class="cls-10" transform="translate(-524.44 402.45) rotate(-60)" x="361.44" y="515.28" width="27.62"
                    height="13.75" rx="5.45" ry="5.45"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.svg-1 {
  width: 100%;
  max-width: 120px;
}

.svg-2 {
  width: 100%;
  max-width: 120px;
}

.svg-3 {
  width: 100%;
  max-width: 120px;
}

.cls-1,
.cls-8 {
  fill: none
}

.cls-1 {
  stroke: #333;
  stroke-width: 5px
}

.cls-1,
.cls-8,
.cls-9 {
  stroke-miterlimit: 10
}

.cls-3,
.cls-4,
.cls-8 {
  stroke: #212121
}

.cls-9 {
  stroke: #ffffff
}

.cls-10 {
  fill: #757575
}

</style>

<script>
export default {
  props: [
    'palette'
  ]
}
</script>